export const UPDATE_PM_REVIEW_MUTATION = `
  mutation UpdatePmReview($filter: String!, $input: PmReviewUpdateInput!) {
    updatePmReview(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const INSERT_PM_REVIEW_DETAIL_MUTATION = `
  mutation InsertPmReviewDetail($input: PmReviewDetailInsertInput!) {
    insertPmReviewDetail(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_PM_REVIEW_DETAIL_MUTATION = `
  mutation UpdatePmReviewDetail($filter: String!, $input: PmReviewDetailUpdateInput!) {
    updatePmReviewDetail(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_PM_REVIEW_DETAIL_MUTATION = `
  mutation DeletePmReviewDetail($filter: String!, $input: PmReviewDetailDeleteInput!) {
    deletePmReviewDetail(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
